import { render } from "./App.vue?vue&type=template&id=0c0e1ab0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0c0e1ab0&lang=less"

import exportComponent from "E:\\Source\\平台项目\\YUNCar\\Source\\Delivery.Mobile.UI\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__